import React from "react";
import Button from "@atoms/Button/Button";
import { useTranslation } from "react-i18next";
import {
	usePageConfiguration,
	PageConfigurationName,
} from "@hooks/usePageConfiguration";
import Link from "@components/Link";

interface Props {
	buttonProps?: any;
	linkProps?: any;
	target?: any;
}

const SelfEmploymentLink: React.FC<Props> = ({
	buttonProps,
	linkProps,
	target,
}) => {
	const { t } = useTranslation();
	const data = usePageConfiguration({
		name: PageConfigurationName.selfEmployment,
	});

	const pageConfiguration = data ? data : {};

	if (buttonProps) {
		return (
			<Link to={`/${pageConfiguration.slug}`} target={target}>
				<Button {...buttonProps} label={t("link.to.self.employment")} />
			</Link>
		);
	}
	return (
		<Link {...linkProps} to={`/${pageConfiguration.slug}`} target={target}>
			{t("link.to.self.employment")}
		</Link>
	);
};

export default SelfEmploymentLink;
